import { render, staticRenderFns } from "./penginapan.vue?vue&type=template&id=4b71ac95&"
import script from "./penginapan.vue?vue&type=script&lang=js&"
export * from "./penginapan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports